// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textinput-parent {
  display: block;
  width: 100%;
  height: 40px;
  position: relative;
}
.textinput-parent .textinput {
  display: block;
  width: 100%;
  height: 100%;
  padding: 12px;
  line-height: 12px;
  color: var(--dark-color-dark);
  background-color: var(--input-bg-color);
  background-clip: padding-box;
  border: 1px solid var(--border-color);
  appearance: none;
  border-radius: 4px;
  transition: all 0.15s;
}
.textinput-parent .textinput::placeholder {
  color: #c2c8d2;
  opacity: 1;
}
.textinput-parent .textinput:focus {
  background-color: var(--input-bg-color);
  border: 1px solid var(--primary-color-main);
  outline: 0;
}
.textinput-parent .textinput:disabled {
  background: var(--disabled-bg-color);
  color: var(--disabled-font-color);
  cursor: default;
  -webkit-appearance: none;
  border: 1px solid var(--disabled-border-color);
}
.textinput-parent .validate-message {
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  font-size: var(--text-size-small);
  color: var(--danger-color-main);
  text-align: left;
  padding-left: 12px;
  background-color: var(--white-color-lightest);
  border-radius: 2px;
  display: none;
}
.textinput-parent .validate-message.show {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/TextInput.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACJ;AACI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAAN;AAEM;EACE,cAAA;EACA,UAAA;AAAR;AAGM;EACE,uCAAA;EACA,2CAAA;EACA,UAAA;AADR;AAIM;EACE,oCAAA;EACA,iCAAA;EACA,eAAA;EACA,wBAAA;EACA,8CAAA;AAFR;AAMI;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,iCAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;EAEA,6CAAA;EACA,kBAAA;EAEA,aAAA;AANN;AAOM;EACE,cAAA;AALR","sourcesContent":[".textinput-parent {\r\n    display: block;\r\n    width: 100%;\r\n    height: 40px;\r\n    position: relative;\r\n\r\n    .textinput {\r\n      display: block;\r\n      width: 100%;\r\n      height: 100%;\r\n\r\n      padding: 12px;\r\n      line-height: 12px;\r\n      color: var(--dark-color-dark);\r\n      background-color: var(--input-bg-color);\r\n      background-clip: padding-box;\r\n      border: 1px solid var(--border-color);\r\n      appearance: none;\r\n      border-radius: 4px;\r\n      transition: all 0.15s;\r\n\r\n      &::placeholder {\r\n        color: #c2c8d2;\r\n        opacity: 1;\r\n      }\r\n\r\n      &:focus {\r\n        background-color: var(--input-bg-color);\r\n        border: 1px solid var(--primary-color-main);\r\n        outline: 0;\r\n      }\r\n\r\n      &:disabled {\r\n        background: var(--disabled-bg-color);\r\n        color: var(--disabled-font-color);\r\n        cursor: default;\r\n        -webkit-appearance: none;\r\n        border: 1px solid var(--disabled-border-color);\r\n      }\r\n    }\r\n\r\n    .validate-message{\r\n      position: absolute;\r\n      bottom: -20px;\r\n      left: 0;\r\n      right: 0;\r\n      font-size: var(--text-size-small);\r\n      color: var(--danger-color-main);\r\n      text-align: left;\r\n      padding-left: 12px;\r\n\r\n      background-color: var(--white-color-lightest);\r\n      border-radius: 2px;\r\n\r\n      display: none;\r\n      &.show {\r\n        display: block;\r\n      }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
